import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconSvg, If, Text, Tooltip } from '@/lib/v2/components';
import { InfoIcon } from '@/lib/v2/icons/outline';

export type ShippingMetricsType = 'ONSITE' | 'SMS' | 'INBOX' | 'EMAIL';

export interface ShippingMetricsTooltip {
  IMPRESSIONS?: string;
  OPENED?: string;
  CLICKED?: string;
  CLICKS?: string;
  UNSUBSCRIBED?: string;
  FAILED?: string;
  BOUNCES?: string;
  CLEANED?: string;
  HITS?: string;
  // cspell:disable
  CONVERSIONRATE?: string;
  // cspell:enable
}

export const METRIC_TOOLTIPS: Record<ShippingMetricsType, ShippingMetricsTooltip> = {
  ONSITE: {
    IMPRESSIONS: 'shipping.tooltipMetrics.ONSITE.tooltipImpressions',
    HITS: 'shipping.tooltipMetrics.ONSITE.tooltipHits',
    CLICKS: 'shipping.tooltipMetrics.ONSITE.tooltipClicks',
    // cspell:disable
    CONVERSIONRATE: 'shipping.tooltipMetrics.ONSITE.tooltipConversionRate',
    // cspell:enable
  },
  SMS: {
    CLEANED: 'shipping.tooltipMetrics.SMS.tooltipCleaned',
  },
  INBOX: {
    CLEANED: 'shipping.tooltipMetrics.INBOX.tooltipCleaned',
  },
  EMAIL: {
    CLEANED: 'shipping.tooltipMetrics.EMAIL.tooltipCleaned',
  },
};

export interface ShippingMetricsTooltipProps {
  label: string;
  tooltipKey: string;
  metricType: ShippingMetricsType;
}

const ShippingMetricsTooltip = ({ label, tooltipKey, metricType }: ShippingMetricsTooltipProps) => {
  const { t } = useTranslation(['insights']);
  const tooltip = METRIC_TOOLTIPS?.[metricType]?.[tooltipKey as keyof ShippingMetricsTooltip];
  return (
    <div className="relative flex items-center">
      {label}
      <div className="absolute -right-7 -top-1">
        <If condition={!!tooltip}>
          <Tooltip
            isDark
            alignment="center"
            content={
              <Text alignment="left" className="w-40 text-white" variant="text-sm">
                {tooltip && t(tooltip)}
              </Text>
            }
            position="top"
          >
            <IconSvg height="12" strokeColor="secondary" svgComponent={<InfoIcon />} width="12" />
          </Tooltip>
        </If>
      </div>
    </div>
  );
};

export default memo(ShippingMetricsTooltip);
